export var AuthenticationReason;
(function (AuthenticationReason) {
    AuthenticationReason["AUTHENTICATOR_REGISTRATION"] = "AUTHENTICATOR_REGISTRATION";
    AuthenticationReason["CARD_VERIFICATION"] = "CARD_VERIFICATION";
    AuthenticationReason["CONSUMER_IDENTITY_VALIDATION"] = "CONSUMER_IDENTITY_VALIDATION";
    AuthenticationReason["ENROL_FINANCIAL_INSTRUMENT"] = "ENROL_FINANCIAL_INSTRUMENT";
    AuthenticationReason["TRANSACTION_AUTHENTICATION"] = "TRANSACTION_AUTHENTICATION";
})(AuthenticationReason || (AuthenticationReason = {}));
//# sourceMappingURL=AuthenticationReason.js.map